import Auth from '@aws-amplify/auth';

export const register = async ({
  firstName,
  lastName,
  email,
  registerPassword,
  farmLocation,
  farmSize,
  termsAgreed,
}) => {
  const attributes = {
    given_name: firstName,
    family_name: lastName,
    email,
    'custom:terms_agreed': termsAgreed,
  };

  // We don't want to send these if they are undefined
  farmLocation && (attributes['custom:farm_location'] = farmLocation);
  farmSize && (attributes['custom:farm_size'] = farmSize);

  return Auth.signUp({
    username: email,
    password: registerPassword,
    attributes,
  });
};

export const login = (username, password) => Auth.signIn(username, password);

export const logout = () => Auth.signOut();

export const forgotPassword = username => Auth.forgotPassword(username);

export const resetPassword = (username, code, password) =>
  Auth.forgotPasswordSubmit(username, code, password);

export const confirmUser = (username, code) =>
  Auth.confirmSignUp(username, code);

export const getCurrentUser = () => Auth.currentAuthenticatedUser();



// WEBPACK FOOTER //
// ./src/api/auth.js